import loadable from '@loadable/component';
import { Loader } from '@/components';

export const AsyncWithdrawContractDashboardBroken = loadable(
  () => import('./DashboardBrokenWithdraw'),
  { fallback: <Loader /> },
);
